define((require) => {
    "use strict";

    const ImprovedView  = require("editor/zbone/ImprovedView");
    const Preconditions = require("shared/util/Preconditions");
    const template      = require("services/rangeInput/RangeInput.tpl");

    const SLIDER_VALUE_INPUT_WIDTH = 30;
    const SLIDER_THUMB_SIZE = 15;
    const SLIDER_THUMB_ADJUSTMENT = (SLIDER_VALUE_INPUT_WIDTH - SLIDER_THUMB_SIZE) / 2;
    const DEFAULT_STEP = 10;
    const DEFAULT_MIN_VAL = 0;
    const DEFAULT_MAX_VAL = 100;

    function identity(x) { return x; }
    /**
     * The RangeInput class takes various attributes to customize the slider
     * (step, minVal, maxVal, unit, minLabel, maxLabel)
     */
    return ImprovedView.extend({
        _onGetConverter: null,
        _onSetConverter: null,
        _modelAttribute: null,
        _minVal: null,
        _maxVal: null,
        _sliderWidth: null,

        template,

        templateHelpers() {
            return {
                step: this.options.step || DEFAULT_STEP,
                minVal: this.options.minVal || DEFAULT_MIN_VAL,
                maxVal: this.options.maxVal || DEFAULT_MAX_VAL,
                staticVal: this.options.staticVal,
                unit: this.options.unit,
                minLabel: this.options.minLabel,
                maxLabel: this.options.maxLabel
            };
        },

        ui: {
            slider: ".slider",
            sliderValue: ".slider-value",
            staticValue: ".static-value",
            sliderLeftColor: ".slider-left-color"
        },

        onRender() {
            Preconditions.isModel(this.options.model);
            Preconditions.isString(this.options.modelAttribute);

            this._modelAttribute = this.options.modelAttribute;
            this._onGetConverter = this.options.onGetConverter || identity;
            this._onSetConverter = this.options.onSetConverter || identity;
            this._minVal = this.options.minVal || DEFAULT_MIN_VAL;
            this._maxVal = this.options.maxVal || DEFAULT_MAX_VAL;
            this._bindSliderToModel();

            this.listenTo(this.model, `change:${this._modelAttribute}`, this._modelAttributeChangeHandler);
            this._updateDynamicValuePosition(this.model.get(this._modelAttribute));
            this._updateStaticValuePosition(this.options.staticVal);
            this._colorTheBar(this._onGetConverter(this.model.get(this._modelAttribute)));
        },

        /**
         * To be able to use the modelAttribute from the options object
         * we set up Stickit bindings manually
         */
        _bindSliderToModel() {
            this.stickit(this.model, {
                ".slider": {
                    observe: this._modelAttribute,
                    onSet(value) {
                        return this._onSetConverter(parseInt(value, 10));
                    },
                    onGet(value) {
                        return this._onGetConverter(value);
                    }
                },
                ".slider-value": {
                    observe: this._modelAttribute,
                    onGet(value) {
                        return this._onGetConverter(value);
                    }
                }
            });
        },

        _modelAttributeChangeHandler(model, value) {
            this._updateDynamicValuePosition(value);
            this._colorTheBar(this._onGetConverter(value));
        },

        _updateDynamicValuePosition(value) {
            this.ui.sliderValue.css(this._calculateValuePosition(this._onGetConverter(value)));
        },

        _updateStaticValuePosition(value) {
            this.ui.staticValue.css(this._calculateValuePosition(value));
        },

        _calculateValuePosition(displayValue) {
            let   left          = ((displayValue - this._minVal) * 100) / (this._maxVal - this._minVal);
            const marginLeft    = ((left / 100) * SLIDER_THUMB_SIZE) + SLIDER_THUMB_ADJUSTMENT;

            left = Math.max(left, 0);
            left = Math.min(left, 100);

            return {left: `${left}%`, marginLeft: -marginLeft};
        },

        _colorTheBar(displayValue) {
            const leftWidth = ((displayValue - this._minVal) * 100) / (this._maxVal - this._minVal);
            this.ui.sliderLeftColor.css({
                width: `${leftWidth}%`
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/services/rangeInput/RangeInput.js